import AlertsPanel from 'components/alerts/AlertsPanel';
import TenantSwitcher from 'components/tenants/TenantSwitcher';

export default function CrmHeaderExtras() {
  return (
    <>
      <TenantSwitcher />
      <AlertsPanel />
    </>
  );
}
